import {
  ChangeDetectorRef,
  Component,
  HostListener,
  Injector,
  Input,
  OnInit,
  ViewChild,
  numberAttribute
} from '@angular/core';
import { Router } from '@angular/router';
import { ACLService } from '@delon/acl';
import { _HttpClient, SettingsService } from '@delon/theme';
import { NzModalService } from 'ng-zorro-antd/modal';
import { ReceivePaymentService } from 'src/app/routes/ar/receive-payment/aror.service';

import { EInvoiceService } from '../../../core/services/e-invoice.service';
import { DepositComponent } from '../deposit/deposit.component';

@Component({
  selector: 'app-tranx-summary',
  templateUrl: './tranx-summary.component.html',
  styleUrls: ['./tranx-summary.component.less'],
  standalone: false
})
export class TranxSummaryComponent implements OnInit {
  @ViewChild('deposit') deposit!: DepositComponent;

  country = 'MY';
  screenWidth: number = window.innerWidth;

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.screenWidth = window.innerWidth;
  }

  // To mask the values of the summary(Display "*****"), set this to true
  @Input() protected = false;
  @Input() currency: string = '';

  @Input() amountExemptedFromTax: number | null | undefined = 0;
  @Input() taxExemptionTotalAmount: number | null | undefined = 0;
  @Input() totalDiscount: number | null | undefined;
  @Input() taxable: number | null | undefined = 0;
  @Input() taxInclusive: number | null | undefined = 0;
  @Input() taxAmount: number | null | undefined = 0;
  @Input() totalAmount: number | null | undefined = 0;
  @Input() wtaxAmount: number | null | undefined = 0;
  @Input() wvatAmount: number | null | undefined = 0;
  @Input() netTotalAmount: number | null | undefined = 0;
  @Input() outstandingAmount: number | null | undefined = 0;
  @Input() roundingAdjustment: number | null | undefined = 0;
  @Input() subTotalAmount: number | null | undefined = 0;

  @Input() hideTotal = false;
  @Input() showWVat = false;
  @Input() showTaxIncl = false; // WI 16615 (cs cp only)
  @Input() showOutstanding = false; // WI 16615 (cs cp only)
  @Input() showTotalPaid = false; // einv PaymentInfo tab (sinv sdn pinv pdn only)
  @Input() showDeposit = false; // Only for QT, SO, DO, SINV

  @Input() depositInfo: {
    groupInfo: any;
    editable: boolean;
  } | null = null;

  get depositAmount() {
    if (this.deposit?.getTotalAmount()) return this.deposit.getTotalAmount();
    else if (this.depositInfo?.groupInfo?.totalAmount)
      return this.depositInfo?.groupInfo?.totalAmount;
    else return 0;
  }

  get showDisc() {
    if (this.totalDiscount === null || this.totalDiscount === undefined)
      return false;
    return true;
  }

  constructor(
    private settings: SettingsService,
    private injector: Injector,
    public eInvoiceSrv: EInvoiceService,
    private modalSrv: NzModalService,
    private http: _HttpClient,
    private cdr: ChangeDetectorRef,
    private router: Router
  ) {
    this.country = this.settings.user['company']?.country;
    this.screenWidth = window.innerWidth;
  }

  get acl() {
    return this.injector.get(ACLService);
  }

  ngOnInit(): void {
    return;
  }

  getTotalPaid(): number {
    if (
      this.netTotalAmount == undefined ||
      this.netTotalAmount == null ||
      this.outstandingAmount == undefined ||
      this.outstandingAmount == null ||
      this.netTotalAmount - this.outstandingAmount < 0
    )
      return 0;
    else return this.netTotalAmount - this.outstandingAmount;
  }

  getSubtotal(): number {
    if (this.subTotalAmount) return this.subTotalAmount;

    if (
      this.totalAmount == undefined ||
      this.totalAmount == null ||
      this.totalDiscount == undefined ||
      this.totalDiscount == null ||
      this.totalAmount - this.totalDiscount < 0
    )
      return 0;
    else return this.totalAmount - this.totalDiscount;
  }

  getDeposits() {
    return this.deposit.getDeposits();
  }

  navigateToDepositPayment() {
    if (this.depositInfo?.groupInfo?.fromType) {
      switch (this.depositInfo?.groupInfo?.fromType) {
        case 'QT':
          this.router.navigateByUrl(
            `/sale/qt/detail/${this.depositInfo.groupInfo.fromReferenceId}`
          );
          break;
        case 'SO':
          this.router.navigateByUrl(
            `/sale/so/detail/${this.depositInfo.groupInfo.fromReferenceId}`
          );
          break;
        case 'DO':
          this.router.navigateByUrl(
            `/sale/do/detail/${this.depositInfo.groupInfo.fromReferenceId}`
          );
          break;
        default:
          this.router.navigateByUrl(
            `/sale/inv/detail/${this.depositInfo.groupInfo.fromReferenceId}`
          );
          break;
      }
    }
  }
}
